import styled from 'styled-components';
import { Col as Col_, Row as Row_ } from 'reactstrap';

export const ButtonDiv = styled.div `
    align-items: center;
    display: flex;
    gap: 40px;
    justify-content: center;
    height: 100px;
    text-align: center;
`;

export const Col = styled(Col_)`

`;

export const Container = styled.div`
    height: 100%;
    padding: 5px;
`;

export const Content = styled.div `
    height: calc(100% - 110px);
    overflow-y: auto;
    padding: 10px;
`;

export const Row = styled(Row_)`
    align-items: center;
    display: flex;
    width: 100%;
`;

export const Text = styled.div`
    color: ${ ({ theme: { textColor } }) => textColor };
    font-size: 14px;
    margin-left: 15px;
`;
